var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M8.20723 10C7.76178 10 7.53869 10.5386 7.85368 10.8536L11.6466 14.6464C11.8418 14.8417 12.1584 14.8417 12.3537 14.6464L16.1466 10.8536C16.4615 10.5386 16.2385 10 15.793 10H8.20723Z"}})}
var staticRenderFns = []

export { render, staticRenderFns }